import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4d019489")

_pushScopeId("data-v-4d019489")
const _hoisted_1 = /*#__PURE__*/_createVNode("h2", null, "予約変更", -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("戻る ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("削除 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("変更 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("予約変更してもいいですか？ ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("予約を削除してもいいですか？ ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_vue_title = _resolveComponent("vue-title")
  const _component_patient_time_form = _resolveComponent("patient-time-form")
  const _component_patient_time_table = _resolveComponent("patient-time-table")
  const _component_vue_two_column_content = _resolveComponent("vue-two-column-content")
  const _component_vue_content_remain = _resolveComponent("vue-content-remain")
  const _component_normal_button = _resolveComponent("normal-button")
  const _component_vue_button_frame = _resolveComponent("vue-button-frame")
  const _component_confirm = _resolveComponent("confirm")
  const _component_vue_frame = _resolveComponent("vue-frame")

  return (_openBlock(), _createBlock(_component_vue_frame, null, {
    default: _withId(() => [
      _createVNode(_component_vue_title, null, {
        default: _withId(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      _createVNode(_component_vue_content_remain, null, {
        default: _withId(() => [
          _createVNode(_component_vue_two_column_content, null, {
            left: _withId(() => [
              _createVNode(_component_patient_time_form)
            ]),
            right: _withId(() => [
              _createVNode(_component_patient_time_table)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_vue_button_frame, null, {
        left: _withId(() => [
          _createVNode(_component_normal_button, {
            class: "vue-button-frame-button",
            state: "normal",
            onClick: _ctx.onPrev
          }, {
            default: _withId(() => [
              _hoisted_2
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        right: _withId(() => [
          _createVNode(_component_normal_button, {
            class: "vue-button-frame-button",
            state: "delete",
            disabled: _ctx.appointmentId === '',
            onClick: _ctx.onDelete
          }, {
            default: _withId(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]),
          _createVNode(_component_normal_button, {
            class: "vue-button-frame-button",
            state: "warning",
            disabled: _ctx.errorStartTime !== undefined || _ctx.errorEndTime !== undefined || _ctx.overlap,
            onClick: _ctx.onUpdate
          }, {
            default: _withId(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ]),
        _: 1
      }),
      _createVNode(_component_confirm, {
        ref: "confirmUpdateRef",
        onYes: _ctx.yesUpdate
      }, {
        default: _withId(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["onYes"]),
      _createVNode(_component_confirm, {
        ref: "confirmDeleteRef",
        onYes: _ctx.yesDelete
      }, {
        default: _withId(() => [
          _hoisted_6
        ]),
        _: 1
      }, 8, ["onYes"])
    ]),
    _: 1
  }))
})